if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    collectAddableVariants(variants, totalQuantity) {
      const addableVariants = [];

      for (let variant of variants) {
        // Assuming each variant object has a 'quantity' property
        if (totalQuantity != 0 && variant.quantity > 0) {
          if (variant.quantity >= totalQuantity) {
            addableVariants.push({ id: variant.id, quantity: totalQuantity });
            totalQuantity = 0
          } else {
            addableVariants.push({ id: variant.id, quantity: variant.quantity });
            totalQuantity -= variant.quantity;
          }
        }
      }

      return addableVariants;
    }

    buildFormData(formData, key, data) {
      if (data === Object(data) || Array.isArray(data)) {
        for (const i in data) this.buildFormData(formData, `${key}[${i}]`, data[i]);
      } else data && formData.append(key, data);
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      const response = await fetch(`/products/${this.getAttribute('data-handle')}?view=data`);

      const data = await response.text();

      var htmlObject = document.createElement('div');
      htmlObject.innerHTML = data;

      const product_data = htmlObject.querySelector('#product_data');

      if (product_data) {
        const product_data_json = JSON.parse(product_data.innerHTML);
        const currentId = formData.get('id');
        let currentQuantity = formData.get('quantity');
        const currentVariant = product_data_json.variants.find((variant) => variant.id == currentId);

        const isAnyItemAvaible = product_data_json.variants.some((variant) => variant.quantity > 0);

        if(currentQuantity > currentVariant.quantity && isAnyItemAvaible) {
          formData.delete('id');
          formData.delete('quantity');
          formData.delete('product-id');
  
          const items = this.collectAddableVariants(product_data_json.variants, currentQuantity)
  
          this.buildFormData(formData, 'items', items);
        }
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          console.log(response)
          if (response.status) {
            this.handleErrorMessage(response.description);
            document.querySelector('.product__info-wrapper .quantity__input').value = document.querySelector('.product__info-wrapper .quantity__input').getAttribute('value');
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
